module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.site.siteName))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.site.siteId))]), _vm._v(" "), (_vm.site.tenancy && _vm.isArray(_vm.site.tenancy)) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": 'Site has ' + _vm.plural('landowner', _vm.site.tenancy.length, true),
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.site.address && _vm.site.zone) ? _c('span', [_vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.site.zone))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.site.subdistrict))]), _vm._v(" "), (_vm.site.district) ? _c('i', [(_vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.district))]) : _vm._e(), _vm._v(" "), (_vm.site.state) ? _c('i', [(_vm.site.district || _vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.state))]) : _vm._e(), _vm._v(" "), (_vm.site.region) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.state) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.region))]) : _vm._e(), _vm._v(" "), (_vm.site.country) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.region || _vm.site.state) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.country))]) : _vm._e()])], 1), _vm._v(" "), (_vm.site.address || _vm.site.zone) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [(_vm.site.address) ? _c('strong', [_vm._v(_vm._s(_vm.site.address) + " ")]) : _vm._e(), _vm._v(" "), (_vm.site.zone) ? _c('span', [_vm._v("Zone: "), _c('strong', [_vm._v(_vm._s(_vm.site.zone))])]) : _vm._e()]), _vm._v(" "), (_vm.site.latitude && _vm.site.longitude) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('small', [_vm._v("lat:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.site.latitude))]), _vm._v(" / "), _c('small', [_vm._v("lng:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.site.longitude))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tabs', [(_vm.tenancy) ? _c('el-tab-pane', {
    attrs: {
      "label": "Tenancy",
      "icon": "fa fa-map"
    }
  }, [(!_vm.isArray(_vm.tenancy)) ? _c('div', [_c('tenancy', {
    attrs: {
      "row-data": _vm.rowData,
      "index": 0,
      "tenancy-data": _vm.tenancy,
      "show-renewal-button": true,
      "hide-delete": true,
      "editable": false
    }
  })], 1) : _c('div', _vm._l((_vm.tenancy), function(t, index) {
    return _c('el-collapse', {
      key: index,
      attrs: {
        "accordion": ""
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s((index + 1) + ')') + " "), _c('b', [_vm._v(_vm._s(t.owner && t.owner.name ? t.owner.name : 'Not Found'))])])]), _vm._v(" "), _c('tenancy', {
      attrs: {
        "row-data": _vm.rowData,
        "index": index,
        "tenancy-data": t,
        "show-agreement": true,
        "hide-delete": true,
        "editable": false
      }
    })], 2)], 1)
  }), 1)]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Location Map",
      "icon": "fa fa-map"
    }
  }, [(_vm.site.site_id ? _vm.site.site_id : _vm.site.id) ? _c('site-card', {
    ref: "siteCard",
    attrs: {
      "site-data": _vm.site,
      "no-shadow": "",
      "sharer-id": _vm.isTelco() ? this.org().id : null
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Sharer",
      "icon": "fa fa-wifi"
    }
  }, [_c('site-sharers', {
    attrs: {
      "no-add": true,
      "read-only": true,
      "row-data": _vm.site
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.site.handover) ? _c('small', [_vm._v("Handover ")]) : _vm._e(), _vm._v(" \n    "), (_vm.site.handover) ? _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.site.handover)))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_vm._v("\n       "), (_vm.site.billing) ? _c('small', [_vm._v("Commencement")]) : _vm._e(), _vm._v(" "), (_vm.site.billing) ? _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.site.billing)))]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3beed87c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/PropertyDetails.vue
// module id = 1516
// module chunks = 0